let range = 1 / 1000
let vw = range * Math.min(window.innerWidth, window.innerHeight)

document.documentElement.style.setProperty('--ball-scale', `${vw}`)

window.addEventListener('resize', () => {
    document.documentElement.style.setProperty('--ball-scale', `${range * Math.min(window.innerWidth, window.innerHeight)}`)
})
